export default __webpack_public_path__ + "static/media/fridge1-after2-480w.0bfafc0a.png";